import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
// components
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: 'Overview',
        items: [
          {
            title: 'Requests',
            path: paths.dashboard.sellRequests.root,
            icon: ICONS.ecommerce,
          },
          {
            title: 'Collection Events',
            path: paths.dashboard.collectionEvents.root,
            icon: <Iconify icon="bxs:calendar-event" />,
          },
          {
            title: 'Users',
            path: paths.dashboard.users.root,
            icon: <Iconify icon="bxs:user-detail" />,
          },
          {
            title: 'Easystore Order',
            path: paths.dashboard.easystoreOrders.root,
            icon: ICONS.invoice,
          },
        ],
      },
    ],
    []
  );

  return data;
}
